var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "640.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 640.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#3E5670",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3025 12600 c-105 -27 -172 -55 -262 -107 -334 -194 -584 -551 -648 -927 -102 -601 373 -1243 975 -1317 248 -30 519 62 760 258 206 168 359 404 427 660 22 84 26 119 26 243 0 101 -5 167 -16 218 -59 256 -182 477 -372 667 -218 218 -453 326 -709 324 -75 0 -134 -6 -181 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707 10060 c-185 -32 -314 -124 -448 -322 -81 -119 -112 -210 -129 -379 -14 -145 -14 -3249 0 -3369 30 -240 95 -381 208 -448 44 -25 54 -27 167 -27 116 0 123 1 187 33 101 50 152 124 185 275 14 63 17 208 22 1143 5 887 8 1074 20 1087 22 28 77 22 98 -10 17 -26 18 -207 23 -3738 5 -3409 7 -3714 22 -3763 52 -166 147 -287 273 -347 90 -43 152 -55 279 -55 290 0 487 135 562 385 17 57 19 165 24 1870 5 1730 6 1812 23 1852 29 65 74 69 99 10 10 -26 14 -377 18 -1847 l5 -1815 28 -69 c85 -213 253 -367 443 -406 84 -18 198 -9 263 20 140 62 284 223 360 402 l26 63 3 430 c2 237 6 1906 10 3710 8 3578 4 3335 64 3335 57 0 56 20 61 -960 3 -588 9 -931 16 -1000 37 -330 121 -501 264 -541 59 -17 175 -15 219 4 152 65 242 280 267 645 6 88 11 762 12 1692 2 1540 2 1545 -19 1602 -84 231 -216 395 -384 477 -151 75 -62 71 -1731 70 -821 -1 -1514 -5 -1540 -9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.deb569760143f581ec7c2f7bcc65b00d.svg";
export { ForwardRef as ReactComponent };